import { createSvgIcon } from '../Utils/helpers';
export default createSvgIcon({
  name: 'ArrowUp',
  width: 1024,
  height: 1024,
  // eslint-disable-next-line max-len, comma-spacing
  paths: ['M1023.982 701.593l-511.98-530.923-511.98 530.923 146.213 151.717 365.767-379.334 365.639 379.334 146.341-151.717z']
});